import React from 'react';

// const ArchiveIcon = ({ onClick }) => (

//   <svg 
//     className="archive-icon"
//     width="14" 
//     height="14" 
//     viewBox="0 0 14 14" 
//     fill="none" 
//     xmlns="http://www.w3.org/2000/svg"
//     onClick={onClick}
//   >
//     <path d="M7 11.6667L10.1111 8.55556L9.02222 7.46667L7.77778 8.71111V5.44444H6.22222V8.71111L4.97778 7.46667L3.88889 8.55556L7 11.6667ZM0 14V2.17778L1.78889 0H12.2111L14 2.17778V14H0ZM1.86667 2.33333H12.1333L11.4722 1.55556H2.52778L1.86667 2.33333Z" fill="#DFA226"/>
//   </svg>
  
// );


// export default ArchiveIcon;


const ArchiveIcon = ({ onClick, isArchived }) => (
  <>
    {isArchived ? (
      <svg
        className="unarchive-icon cr-pointer"
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
      >
        <path d="M0 28V4.35556L3.57778 0H24.4222L28 4.35556V28H0ZM3.73333 4.66667H24.2667L22.9444 3.11111H5.05556L3.73333 4.66667Z" fill="#094C80" />
        <path d="M12.5 23L15.5 23L15.5 16.5L18 19L20 17L14 11L8 17L10 19L12.5 16.5L12.5 23Z" fill="white" />
      </svg>
      
    ) : (
      <svg 
        className="archive-icon"
        xmlns="http://www.w3.org/2000/svg" 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none"
        onClick={onClick}
      >
        <path d="M21 3H3C2.44772 3 2 3.44772 2 4V7C2 7.55228 2.44772 8 3 8H21C21.5523 8 22 7.55228 22 7V4C22 3.44772 21.5523 3 21 3Z" stroke="#BD3D44" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4 8V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V8" stroke="#BD3D44" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 11V16" stroke="#BD3D44" stroke-width="2"/>
        <path d="M15 13.5L12 16.5L9 13.5" stroke="#BD3D44" stroke-width="2"/>
      </svg>
    )}
  </>
);

export default ArchiveIcon;
